import React, { useState } from "react";
import toast from "react-hot-toast";
import {
  getCurrentFYByDate,
  minutesToHHMM,
  secondsToHHMM,
  timeToSeconds,
} from "../../Utilitie";

const NKJTerminalDetentionIns = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const [globalDate, setGlobalDate] = useState(
    new Date().toISOString().slice(0, 7),
  );
  const fyData = getCurrentFYByDate(globalDate) || {};

  const [entries, setEntries] = useState([
    {
      total_rakes: "",
      arr_to_block: "",
      block_to_release: "",
      release_to_shunting_start: "",
      shunting_time: "",
      shunting_complition_to_load_ready: "",
      load_ready_to_pressure_advice: "",
      pressure_time: "",
      pressure_resdy_to_despatch: "",
      total_detention: "",
      C_and_W_A_C_1_2_7: "",
      tfc_A_C_3_4_5_6_8: "",
    },
  ]);

  const keys = [
    "total_rakes",
    "arr_to_block",
    "block_to_release",
    "release_to_shunting_start",
    "shunting_time",
    "shunting_complition_to_load_ready",
    "load_ready_to_pressure_advice",
    "pressure_time",
    "pressure_resdy_to_despatch",
    "total_detention",
    "C_and_W_A_C_1_2_7",
    "tfc_A_C_3_4_5_6_8",
  ];
  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) => {
        if (i !== rowIndex) return row;

        return {
          ...row,
          [key]:
            keys.includes(key) && key !== "total_rakes"
              ? timeToSeconds(value)
              : value,
        };
      }),
    );
  };

  const addRow = () => {
    setEntries((prev) => [
      ...prev,
      {
        total_rakes: "",
        arr_to_block: "",
        block_to_release: "",
        release_to_shunting_start: "",
        shunting_time: "",
        shunting_complition_to_load_ready: "",
        load_ready_to_pressure_advice: "",
        pressure_time: "",
        pressure_resdy_to_despatch: "",
        total_detention: "",
        C_and_W_A_C_1_2_7: "",
        tfc_A_C_3_4_5_6_8: "",
      },
    ]);
  };

  const removeRow = (index) =>
    setEntries((prev) => prev.filter((_, i) => i !== index));
  const handleClear = () => setEntries([]);

  const handleSubmit = async () => {
    const dataToSend = entries.map((entry) => ({
      ...entry,
      YEAR: fyData.FY.replace("_", "-") || "",
      MONTH: fyData.month.toUpperCase() || "",
    }));
    try {
      const response = await fetch(
        `${urlPrefix}insert/nkj_terminal_detention`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dataToSend),
        },
      );

      const result = await response.json();
      if (!response.ok) throw new Error(result?.message || "HTTP error");

      toast.success("✅ Data uploaded successfully!");
      setEntries([
        {
          total_rakes: "",
          arr_to_block: "",
          block_to_release: "",
          release_to_shunting_start: "",
          shunting_time: "",
          shunting_complition_to_load_ready: "",
          load_ready_to_pressure_advice: "",
          pressure_time: "",
          pressure_resdy_to_despatch: "",
          total_detention: "",
          C_and_W_A_C_1_2_7: "",
          tfc_A_C_3_4_5_6_8: "",
        },
      ]);
    } catch (error) {
      toast.error("❌ Failed to upload data");
      console.error("Upload error:", error);
    }
  };

  const handleDateChange = (value) => {
    setGlobalDate(value);
  };

  return (
    <div className="papaDiv">
      <h5 className="p-2 bg-dark text-white text-center">
        Insert Data in Terminal Detention
      </h5>

      <div className="d-flex justify-content-center align-items-center gap-3 m-3">
        <div>
          <label className="fw-bold me-2">Select Date:</label>
          <input
            type="month"
            className="form-control d-inline-block"
            style={{ width: "180px", fontSize: "0.9rem" }}
            value={globalDate}
            onChange={(e) => handleDateChange(e.target.value)}
          />
        </div>
        <div>
          <span className="badge bg-primary me-2">
            FY: {fyData.FY.replace("_", "-") || "N/A"}
          </span>
          <span className="badge bg-success">
            Month: {fyData.month || "N/A"}
          </span>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 text-center align-middle">
          <thead className="table-dark">
            <tr>
              {keys.map((key, i) => (
                <th key={i}>{key.replace(/_/g, " ").toUpperCase()}</th>
              ))}
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {entries.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {keys.map((key, index) => (
                  <td key={index}>
                    {key === "total_rakes" ? (
                      <input
                        type="number"
                        className="form-control"
                        value={row[key] || ""}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      />
                    ) : (
                      <input
                        type="time"
                        className="form-control"
                        style={{ width: "140px", fontSize: "0.8rem" }}
                        value={row[key] ? secondsToHHMM(row[key]) : ""}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}

                <td>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => removeRow(rowIndex)}
                  >
                    🗑
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center mt-3">
        <button className="btn btn-outline-primary m-2" onClick={addRow}>
          Add Row
        </button>
        <button className="btn btn-outline-danger m-2" onClick={handleClear}>
          Clear
        </button>
        <button className="btn btn-outline-success m-2" onClick={handleSubmit}>
          Upload
        </button>
      </div>
    </div>
  );
};

export default NKJTerminalDetentionIns;
